import React, { useEffect, useState } from 'react';
import './styles/app.scss';
import { BrowserRouter as Router, Routes, Route, useLocation, Outlet, Navigate } from 'react-router-dom';
import Login from './components/Pages/Login/LogIn';
import Dashboard from './components/Pages/Dashboard/Dashboard';
import CustomStatusPage from './shared/pages/custom.status';
import Landing from './components/Pages/Landing/Landing';
import ChangePassword from './components/Pages/ChangePassword/changepassword';
import { PrivateRoute } from './shared/pages/private.route';
import { motion } from 'framer-motion';
import WorkInProgress from './components/WorkInProgress';
//import StoreSummary from './components/StoreSummary';
import OrdersPage from './components/Pages/Orders/OrdersPage';
import StoresPage from './components/Pages/Stores/StoresPage';
import PaymentsPage from './components/Pages/Payments/PaymentsPage';
import ProfileSettings from './components/Pages/Settings/ProfileSettings';
import Header from './components/Header';
import DashboardBrand from './components/Pages/Dashboard/Dashboard.brand';
import SingleStoreView from './components/Pages/Stores/SingleStoreView';
import OtterBrands from './otter/otter.brands';
import Adminhomepage from './components/Admin/homepage/Adminhomepage';
import OnboardBusiness from './components/Admin/onboardbusiness/onboardbusinesslandingpage/OnboardBusiness';
import Createaccountform from './components/Admin/createaccount/createaccountform/Createaccountform';
import OtterStores from './otter/otter.stores';
import TempPassword from './components/Pages/Password/temp-password';
import { CookiesProvider } from 'react-cookie';
import GetStartedPage from './components/Pages/GetStarted/GetStartedPage';
import IACMActivation from './components/Admin/iacmactivation/iacmactivation';
import mixpanel from 'mixpanel-browser';
import { N_A, PAGE_VIEW, TIME_ON_PAGE } from './constants/mixPannelConstants';
import CreateAdminForm from './components/Admin/createadmin/createadmin';
import ManageMerchant from './components/Admin/Managemerchant/Managemerchant';
import MerchantAccount from './components/Admin/MerchantAccount/MerchantAccount';
import { appTokenSaga } from './redux/saga/merchantServiceSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { getAppAccessToken } from './redux/actions/merchantAction';
import { checkCookie, checkPathNeedToken, getTokenTargetDate } from './shared/utils/format.helpers';


const enableBizDev = process.env.REACT_APP_ENABLE_BIZDEV === 'true';
const enablepaymentsTab = process.env.REACT_APP_ENABLE_PAYMENTS_TAB === 'true';
import BusinessInfo from './components/Admin/onboardbusiness/businessInfo/BusinessInfoo';

//mixpanel.init(process.env.MIXPANNEL_PROJECT_TOKEN , {debug: true, track_pageview: true, persistence: 'localStorage'});
// comment the below line and uncomment the above line to debug
mixpanel.init(process.env.MIXPANNEL_PROJECT_TOKEN);


const usePageTracking = () => {
  const location = useLocation();
  const [enterTime, setEnterTime] = useState(null);
  const appTokenSagaSelector = useSelector(appTokenSaga);
  const dispatch = useDispatch();

  useEffect(() => {
    const getPageName = (pathname) => {
      if (pathname === '/') return 'home page';
      if (pathname === '/about') return 'about page';
      if (pathname === '/dashboard') return 'dashboard';
      if (pathname === '/dashboard/orders') return 'orders page';
      if (pathname === '/dashboard/stores') return 'stores page';
      if (/^\/dashboard\/stores\/singlestoreview\/[a-z0-9-]+$/.test(pathname)) return 'single store view page';
	  if(enablepaymentsTab) {
		if (pathname === '/dashboard/payments') return 'payments page';
	  }
      if (pathname === '/dashboard/settings') return 'settings page';
      if (pathname === '/dashboard/adminhomepage') return 'admin home page';
      if (pathname === '/dashboard/createaccount') return 'create admin account page';
      if (pathname === '/dashboard/createadmin') return 'create admin account page';
	  if (pathname === '/dashboard/managemerchants') return 'manage merchants page';
      if (pathname === '/dashboard/activation') return 'activation page';
      if (pathname === '/dashboard/createaccountform') return 'create account form page';
	  if (pathname === '/dashboard/createmerchant') return 'create merchant account page';
	  if(enableBizDev){
		if (pathname === '/dashboard/onboardbusiness') return 'onboard business landing page';
	  }
      return pathname.split('/').filter(Boolean).join(' ') + ' page';
    };
    const handlePageView = () => {
		const pageName = getPageName(location.pathname);
		const enterTime = new Date().getTime();
		setEnterTime(enterTime);
		if (mixpanel && mixpanel.track) {
			mixpanel.track(PAGE_VIEW, {
			PageName: pageName,
			//enterTime: new Date(enterTime).toUTCString(),
			buttonName: N_A,
			EventTime: new Date().toUTCString(),
			timeSpent: N_A,
			outcome: N_A,
			});
		}

      return () => {
        const leaveTime = new Date().getTime();
        const timeSpent = (leaveTime - enterTime) / 1000; // time spent in seconds
		// Track page leave and time spent
		if (mixpanel && mixpanel.track) {
			mixpanel.track(TIME_ON_PAGE, {
				PageName: pageName,
				//leaveTime: new Date(leaveTime).toUTCString(),
				timeSpent: timeSpent+' sec',
				buttonName: N_A,
				EventTime: new Date().toUTCString(),
				outcome: N_A,
			});
		}
      };
    };

    const cleanup = handlePageView();

    return () => {
      cleanup();
    };
  }, [location]);

  useEffect(() => {
    // console.log('appTokenSagaSelector ', appTokenSagaSelector, location.pathname, checkPathNeedToken(location.pathname));
    if(checkPathNeedToken(location.pathname)){
      if (appTokenSagaSelector === null) {
        dispatch(getAppAccessToken());
      } else {
        let targetDate = getTokenTargetDate();
        document.cookie = `_appToken=${appTokenSagaSelector?.access_token};expires=${ targetDate.toUTCString()};path=/;secure`;
      }
    }

    checkCookie(()=> console.log('COOKIE NOT ENABLED'))
    
  }, [appTokenSagaSelector, location]);
};

const PageLayout = ({ children }) => children;

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: 'tween',
  ease: 'linear',
  duration: 0.9,
};

const AnimationLayout = () => {
  usePageTracking();
  const { pathname } = useLocation();
  return (
    <PageLayout>
      {pathname.indexOf('dashboard/') === -1 ? (
        <motion.div key={pathname} initial='initial' animate='in' variants={pageVariants} transition={pageTransition}>
          <Outlet />
        </motion.div>
      ) : (
        <Outlet />
      )}
    </PageLayout>
  );
};

const App = () => {
  return (
    <div className='App' data-testid='app-id'>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <Router>
          <Header />
          <Routes>
            <Route element={<AnimationLayout />}>
              <Route path='/' element={<Landing />} />
              <Route path='/login' element={<Login />} />
              <Route path='/getstarted' element={<GetStartedPage />} />
              <Route
                path='/dashboard'
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate replace to='/dashboard/orders' />} />
                <Route
                  path='orders'
                  element={
                    <PrivateRoute>
                      <OrdersPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='stores'
                  element={
                    <PrivateRoute>
                      <StoresPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='stores/singlestoreview/:storeUUID'
                  element={
                    <PrivateRoute>
                      <SingleStoreView />
                    </PrivateRoute>
                  }
                />
				{ enablepaymentsTab &&
					<Route
					path='payments'
					element={
						<PrivateRoute>
							<PaymentsPage />
						</PrivateRoute>
					}
					/>
				}
                <Route
                  path='settings'
                  element={
                    <PrivateRoute>
                      <ProfileSettings />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='adminhomepage'
                  element={
                    <PrivateRoute>
                      <Adminhomepage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='activation'
                  element={
                    <PrivateRoute>
                      <IACMActivation />
                    </PrivateRoute>
                  }
                />
				<Route
                  path='createmerchant'
                  element={
                    <PrivateRoute>
                      <MerchantAccount />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='createadmin'
                  element={
                    <PrivateRoute>
                      <CreateAdminForm />
                    </PrivateRoute>
                  }
                />
				   <Route
                  path='managemerchants'
                  element={
                    <PrivateRoute>
                      <ManageMerchant />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='createaccountform'
                  element={
                    <PrivateRoute>
                      <Createaccountform />
                    </PrivateRoute>
                  }
                />
				{enableBizDev && 
					<Route path='onboardbusiness'
						element={
							<PrivateRoute>
							<OnboardBusiness />
							</PrivateRoute>
						}
					/>}
				{enableBizDev && 
					<Route path='businessinfo'
						element={
							<PrivateRoute>
							<BusinessInfo />
							</PrivateRoute>
						}
					/>}
               
              </Route>
              <Route path='/otter' element={<Landing orgName='otter' />} />
              <Route path='/iacm' element={<Landing orgName='iacm' />} />
              <Route
                path='/dashboard-brand'
                element={
                  <PrivateRoute>
                    <DashboardBrand />
                  </PrivateRoute>
                }
              />
              <Route path='/workinprogress' element={<WorkInProgress />} />
              <Route path='/intakeformsubmitted' element={<CustomStatusPage statusIndicator='GetStarted_success' />} />
              <Route path='/checkemail' element={<CustomStatusPage statusIndicator='Check_Email' />} />
              <Route
                path='/adduser_success'
                element={
                  <PrivateRoute>
                    <CustomStatusPage statusIndicator='User_Created' />
                  </PrivateRoute>
                }
              />
              <Route
                path='/adduser_failed'
                element={
                  <PrivateRoute>
                    <CustomStatusPage statusIndicator='User_Creation_Failed' />
                  </PrivateRoute>
                }
              />
              <Route
                path='/integration_success'
                element={
                  <PrivateRoute>
                    <CustomStatusPage statusIndicator='Login_Success' />
                  </PrivateRoute>
                }
              />
              <Route
                path='/integration_failed'
                element={
                  <PrivateRoute>
                    <CustomStatusPage statusIndicator='Login_Failed' />
                  </PrivateRoute>
                }
              />
              <Route path='/password_success' element={<CustomStatusPage statusIndicator='Password_Success' />} />
              <Route path='/password_failed' element={<CustomStatusPage statusIndicator='Password_Failed' />} />
              <Route path='/forget_password_failed' element={<CustomStatusPage statusIndicator='Update_Password_OTP_Failed' />} />
              <Route path='/update_password_success' element={<CustomStatusPage statusIndicator='Update_Password_Success' />} />
              <Route path='/update_password_failed' element={<CustomStatusPage statusIndicator='Update_Password_Failed' />} />
              <Route path='/changepassword' element={<ChangePassword />} />
              <Route path='/updatepassword' element={<TempPassword />} />
              <Route
                exact
                path='/terms.html'
                render={() => {
                  window.location.href = 'terms.html';
                }}
              />
              <Route path='*' element={<WorkInProgress />} />
            </Route>
          </Routes>
        </Router>
      </CookiesProvider>
    </div>
  );
};

export default App;
